import { useLocale } from '@locale/translate';

import { FieldText } from './types';
import { getTranslatedFormText } from './utils';

export const useTranslatedFieldText = (text: FieldText) => {
  const locale = useLocale();
  return getTranslatedFormText(text, locale);
};
